module.exports = __webpack_public_path__ + "img/businesscredit@2x.fb15c74.png";